(function () {
  'use strict';

  angular.module('mean.system')
    .controller('StarterController', StarterController);

  StarterController.$inject = ['$scope', 'Global'];

  function StarterController ($scope, Global) {
    // Original scaffolded code.
    $scope.global = Global;
    $scope.package = {
      name: 'inspinia'
    };
  }
})();



// WEBPACK FOOTER //
// ./packages/custom/inspinia/public/controllers/starter.js